var _defs, _defs2, _path, _use, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubemusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "youtubemusic__a",
    fill: "#fff",
    d: "M0 0h32v32H0z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtubemusic__b"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#youtubemusic__a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "youtubemusic__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h22v22H5z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtubemusic__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "youtubemusic__c",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c12.357 0 16 3.643 16 16s-3.643 16-16 16S0 28.357 0 16 3.643 0 16 0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#youtubemusic__c)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#youtubemusic__a"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtubemusic__d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "youtubemusic__e",
    width: 22,
    height: 22,
    x: 5,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#youtubemusic__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M16 27c6.08 0 11-4.92 11-11S22.08 5 16 5 5 9.92 5 16s4.92 11 11 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 10.21A5.8 5.8 0 0 1 21.79 16 5.8 5.8 0 0 1 16 21.79 5.8 5.8 0 0 1 10.21 16 5.8 5.8 0 0 1 16 10.21Zm0-.89A6.68 6.68 0 0 0 9.32 16 6.68 6.68 0 0 0 16 22.68 6.68 6.68 0 0 0 22.68 16 6.68 6.68 0 0 0 16 9.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.88 19.25 19.5 16l-5.62-3.25v6.5Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubemusic);
export default __webpack_public_path__ + "static/media/youtubemusic.53ec6f1da823b21fc42816af12543229.svg";
export { ForwardRef as ReactComponent };